import React from "react";
import { Colors, Fonts } from "../../../shared/theme";
import { textStyles } from "../../../shared/theme/fonts-ppv";

export default {
  page: {
    minHeight: "100vh",
    position: "relative",
    overflow: 'hidden',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(90deg, #fffafc 0%, #ffffff 48%, #f8fbff 100%)",
  } as React.CSSProperties,
  pageTitle: {
    ...textStyles.h4,
    color: Colors.font.primary.lightGray,
    marginBottom: "16px",
  } as React.CSSProperties,
  pageGlowLeft: {
    position: "absolute",
    top: "-10px",
    left: "0px",
    width: "260px",
    height: "460px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(75, 201, 241, 1) 4%, rgba(144, 18, 245, 1) 42%, rgba(240, 18, 228, 1) 95%)",
    filter: "blur(220px)",
    pointerEvents: "none",
  } as React.CSSProperties,
  pageGlowRight2: {
    position: "absolute",
    right: "300px",
    bottom: "0px",
    width: "300px",
    height: "260px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(75, 201, 241, 1) 4%, rgba(144, 18, 245, 1) 42%, rgba(240, 18, 228, 1) 95%)",
    filter: "blur(220px)",
    pointerEvents: "none",
  } as React.CSSProperties,
  pageGlowRight1: {
    position: "absolute",
    right: "-180px",
    bottom: "-40px",
    width: "860px",
    height: "860px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(197, 227, 255, 0.58) 0%, rgba(220, 234, 255, 0.34) 46%, rgba(255, 255, 255, 0) 74%)",
    filter: "blur(2px)",
    pointerEvents: "none",
  } as React.CSSProperties,
  content: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    justifyContent: "center",
    // height: "100vh",
  } as React.CSSProperties,
  card: {
    width: "100%",
    maxWidth: "900px",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    border: "1px solid rgba(255, 255, 255, 0.55)",
    borderRadius: "40px",
    overflow: "hidden",
    boxShadow: "0 12px 30px rgba(0, 0, 0, 0.10)",
    backdropFilter: "blur(24px)",
    WebkitBackdropFilter: "blur(24px)",
    display: "flex",
    flexDirection: "column",
  } as React.CSSProperties,
  hero: {
    width: "100%",
    backgroundColor: "transparent",
  } as React.CSSProperties,
  heroImage: {
    width: "100%",
    display: "block",
    objectFit: "cover",
  } as React.CSSProperties,
  form: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    backgroundColor: "transparent",
  } as React.CSSProperties,
  formSection: {
    padding: "28px 30px 30px",
    display: "flex",
    flexDirection: "column",

    flex: 1,
    minHeight: 0,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  } as React.CSSProperties,
  successSection: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "12px",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  } as React.CSSProperties,
  successAnimation: {
    width: "147px",
    height: "150px",
  } as React.CSSProperties,
  successBox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "14px 16px",
    borderRadius: "16px",
    backgroundColor: "#F3FFF8",
    border: "1px solid #B7EB8F",
  } as React.CSSProperties,
  successText: {
    ...textStyles.subtitle2,
    color: Colors.notifGreen,
    marginBottom: 0,
  } as React.CSSProperties,
  sectionSuccessTitle: {
    ...textStyles.h2,
    color: Colors.grey800,
  } as React.CSSProperties,
  sectionSuccessSubTitle: {
    ...textStyles.subtitle1,
    color: Colors.grey600,
    marginTop: "18px",
    marginBottom: "18px",
  } as React.CSSProperties,
  sectionTitle: {
    ...textStyles.h3,
    color: Colors.grey800,
    marginBottom: "18px",
  } as React.CSSProperties,
  sectionSubtitle: {
    ...textStyles.body2,
    color: Colors.grey600,
    marginTop: "-8px",
    marginBottom: "18px",
  } as React.CSSProperties,
  inputGrid: {
    width: "100%",
    display: "flex",
    gap: "18px",
  } as React.CSSProperties,
  formItem: {
    marginBottom: 0,
    width: "100%",
    minHeight: "84px",
  } as React.CSSProperties,
  inputWrap: {
    position: "relative",
    width: "100%",
  } as React.CSSProperties,
  floatingLabel: {
    position: "absolute",
    top: "-7px",
    left: "10px",
    zIndex: 1,
    padding: "0 4px",
    background: "linear-gradient(to bottom, transparent 40%, white 40%)",
    transition: "0.2s ease all",
    ...textStyles.h6,
    color: Colors.grey400,
  } as React.CSSProperties,
  customPlaceholder: {
    position: "absolute",
    top: "50%",
    left: "44px",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    transition: "0.2s ease all",
    ...textStyles.body2,
    color: Colors.grey400,
    zIndex: 1,
  } as React.CSSProperties,
  input: {
    width: "100%",
    height: "44px",
    borderRadius: "8px",
    borderColor: Colors.grey100,
    boxShadow: "none",
    ...textStyles.body2,
    color: Colors.grey800,
  } as React.CSSProperties,
  inputError: {
    border: `1px solid ${Colors.red600}`,
    borderColor: Colors.red600,
    boxShadow: "none",
  } as React.CSSProperties,
  inputFloating: {
    paddingTop: "14px",
  } as React.CSSProperties,
  inputPrefix: {
    color: Colors.grey400,
    fontSize: "20px",
    marginRight: "10px",
  } as React.CSSProperties,
  inputRule: {
    ...textStyles.body3,
    color: Colors.red600,
  } as React.CSSProperties,
  inputText: {
    color: Colors.grey400,
    fontSize: "20px",
    marginRight: "10px",
  } as React.CSSProperties,
  inputTextWithPrefix: {
    color: Colors.grey400,
    fontSize: "20px",
    marginRight: "10px",
    marginLeft: "30px",
  } as React.CSSProperties,
  termsSection: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  } as React.CSSProperties,
  termsCard: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "18px",
    padding: "20px",
    borderRadius: "20px",
    backgroundColor: Colors.white,
    minHeight: 0,
    border: `1px solid ${Colors.grey100}`,
  } as React.CSSProperties,
  termsScroll: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    overflowY: "auto",
    paddingRight: "8px",
    minHeight: 0,
  } as React.CSSProperties,
  termsText: {
    ...textStyles.body2,
    color: Colors.grey800,
    marginBottom: 0,
    lineHeight: 1.7,
  } as React.CSSProperties,
  termsSubTitle: {
    ...textStyles.subtitle1,
    color: Colors.grey800,
    marginTop: "4px",
    marginBottom: 0,
  } as React.CSSProperties,
  checkboxRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
    ...textStyles.body2,
    color: Colors.grey600,
  } as React.CSSProperties,
  checkboxLabel: {
    ...textStyles.subtitle2,
    color: Colors.grey800,
  } as React.CSSProperties,
  checkboxLabelDisabled: {
    ...textStyles.subtitle2,
    color: Colors.grey200,
  } as React.CSSProperties,
  termsHint: {
    ...textStyles.body3,
    color: Colors.grey600,
    marginBottom: 0,
  } as React.CSSProperties,
  timeGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "18px",
  } as React.CSSProperties,
  radioCard: {
    display: "flex",
    alignItems: "center",
    minHeight: "44px",
    borderRadius: "8px",
    border: `1px solid ${Colors.grey100}`,
    padding: "0 18px",
    backgroundColor: Colors.white,
    cursor: "pointer",
    transition: "all 0.2s ease",
  } as React.CSSProperties,
  radioCardError: {
    border: `1px solid ${Colors.red600}`,
  } as React.CSSProperties,
  radioCardActive: {
    border: `1px solid ${Colors.violet600}`,
  } as React.CSSProperties,
  radio: {
    width: "100%",
    marginRight: 0,
    display: "flex",
    alignItems: "center",
    ...textStyles.subtitle1,
    color: Colors.font.primary.fakeBlack,
  } as React.CSSProperties,
  buttonWrap: {
    marginTop: "auto",
    paddingTop: "8px",
  } as React.CSSProperties,
  submitButton: {
    marginTop: "20px",
    width: "100%",
    height: "56px",
    borderRadius: "999px",
    border: "none",
    ...textStyles.subtitle1,
    color: Colors.white,
    background: Colors.violet,
    boxShadow: "0 18px 30px rgba(122, 53, 240, 0.22)",
  } as React.CSSProperties,
  submitButtonDisabled: {
    boxShadow: "none",
  } as React.CSSProperties,
  exclamationIcon: {
    color: Colors.red600,
    marginRight: "6px",
  } as React.CSSProperties,
};
